import "./App.css";
import { Home } from "Pages/home";
import { DataProtection } from "Pages/dsgvo";
import { Legal } from "Pages/legal";
import { useState } from "react";
import { ModalDialog } from "lib/ModalDialog/dialog";

function App() {
  const [modalDialog, setModalDialog] = useState(null);

  const renderDialogContent = () => {
    switch (modalDialog) {
      case "legal":
        return <Legal setModalDialog={setModalDialog} />;
      case "dataProtection":
        return <DataProtection setModalDialog={setModalDialog} />;
      default:
        return null;
    }
  };
  return (
    <>
      {modalDialog && (
        <ModalDialog setModalDialog={setModalDialog}>
          {renderDialogContent()}
        </ModalDialog>
      )}
      <Home setModalDialog={setModalDialog} />
    </>
  );
}

export default App;
